import { z } from "zod";

const passwordSchema = z
  .object({
    currentPassword: z
      .string()
      .min(1, "Current Password is required"),
    newPassword: z
      .string()
      .min(6, "New Password must be at least 6 characters")
      .regex(/[A-Z]/, "New Password must contain at least one uppercase letter")
      .regex(/[a-z]/, "New Password must contain at least one lowercase letter")
      .regex(/\d/, "New Password must contain at least one number")
      .regex(
        /[!@#$%^&*(),.?":{}|<>]/,
        "New Password must contain at least one special character"
      ),
    confirmPassword: z
      .string()
      .min(1, "Confirm Password is required"),
  })
  .superRefine((data, ctx) => {
    if (data.newPassword !== data.confirmPassword) {
      ctx.addIssue({
        code: "custom",
        message: "Passwords do not match",
        path: ["confirmPassword"],
      });
    }
    if (data.newPassword === data.currentPassword) {
      ctx.addIssue({
        code: "custom",
        message: "New password must be different from current password",
        path: ["newPassword"],
      });
    }
  });

export { passwordSchema };
